import { AfterViewInit, Injectable, OnDestroy } from "@angular/core";
import { BehaviorSubject ,  Subscription } from "rxjs";
import { FieldStateService } from "../../field-state.service";

@Injectable()
export class FileUploadStateService extends FieldStateService implements AfterViewInit, OnDestroy {
    public stateObservable$: BehaviorSubject<any>;
    public stateSubscriber$: Subscription;
    public fieldValue: any[] = [];

    constructor() {
        super();
    }

    public ngAfterViewInit() {
        this.stateSubscriber$ = this.stateObservable$.subscribe((state) => {
            this.fieldValue = state.value || [];
        });
    }

    public ngOnDestroy() {
        this.stateSubscriber$.unsubscribe();
    }

    public dispatchAddValueToStaging(payload): void {
        if (!payload) { return; }
        const files = [...payload].map((file) => {
            file.new = true;
            return file;
        });
        const value = [...this.fieldValue];

        files.forEach((file) => {
            const fileIndex = value.findIndex((_value) => (_value.new && _value.name === file.name));
            if (fileIndex < 0) {
                value.push(file);
            }
        });
        this.stateObservable$.next(super.newState({ value }));
    }

    public dispatchRemoveValueFromStaging(fileIndex: number): void {
        const values = [...this.fieldValue];
        const updatedValues = values.filter((value, i) => i !== fileIndex);
        this.fieldValue = updatedValues;
        this.stateObservable$.next(super.newState({ value: updatedValues }));
    }

    public dispatchFieldUpdate(payload): void {
        this.dispatchAddValueToStaging(payload);
    }

    public dispatchFieldLoad(payload): void {
        const files = [...payload].map((file) => {
            file.new = false;
            return file;
        });
        this.stateObservable$.next(super.newState({ value: files }));
    }
}
